<div class="container " id="page-content-main">
  <div class="mt-4">
    <div class="">
      <mat-card tabindex="0" class="mb-3" style="border-radius: 10px">
        <mat-card-content>
          <a [routerLink]="['/home']" class="ts-l tw-b">
              <span class="fa fa-chevron-circle-left fa-sm-blue" matTooltip="GO BACK"
              matTooltipClass="tooltip-md">
            </span>
            Back
          </a>
          <br><br>
          <div class="container-fluid">
            <h2>Employer FAQ</h2>
            <p>
            <div class="accordion accordion-flush" id="accordionFlushExample">

            <!-------ACH CREDIT ------------->
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-headingOne">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne"
                    style="font-weight: bold;">
                    ACH Credit (EFT/ EDI)
                  </button>
                </h2>
                <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne"
                  data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">

                    <!---------------------------------------------------------------------------------------------->
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          How can I obtain information on the EFT/ EDI process?                        
                        </mat-expansion-panel-header>
                        <div class="mx-2">
                          Download an information packet at this web site or contact the Missouri Family Support Payment Center at 1-888-761-3665.                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>

                    <!---------------------------------------------------------------------------------------------->
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          I recently arranged for a prenote transmission, when can I stop mailing in checks?                        
                        </mat-expansion-panel-header>
                        <div class="mx-2">
                          Five business days are required to validate bank account information that has not been previously verified. 
                          You should continue to remit a check for your employees’ child support withholdings during this five business 
                          day period. You will be notified if the prenote is unsuccessful, at which point you must continue to remit a 
                          check until your bank account information has been successfully verified.         
                        </div>             
                        </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    
                    <!---------------------------------------------------------------------------------------------->
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          What should I do if the wrong amount is withheld from an employee’s paycheck?                        
                        </mat-expansion-panel-header>
                        <div class="mx-2">
                          Contact the child support office that handles the case.                      
                        </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <br>       
                    
                    <!---------------------------------------------------------------------------------------------->
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Can I transmit a debit transaction (reversal) if there is a mistake?                        
                        </mat-expansion-panel-header>
                        <div class="mx-2">
                          No, debit transactions are not allowed.                        
                        </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <br>                       

                  </div>
                </div>
              </div>

            <!-------ACH DEBIT---------------------->
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-headingTwo">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo"
                    style="font-weight: bold;">
                    ACH Debit
                  </button>
                </h2>
                <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo"
                  data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">

                    <!------BANK DRAFT------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Questions about Scheduling a Bank Draft
                        </mat-expansion-panel-header>
                          <mat-accordion multi>
                            <mat-expansion-panel>
                              <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                                <div class="m-3">
                                  What should I do to have child support payments automatically withdrawn from my bank account?
                                </div>
                              </mat-expansion-panel-header>
                              <div class="mx-4">
                                Click Employer at this web site, register an account, and schedule a payment.
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>
                          <!------------------------------------------------------------------------------------------------>
                          <mat-accordion multi>
                            <mat-expansion-panel>
                              <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                                <div class="m-3">
                                  What information is required to register an account on the web site?
                                </div>
                              </mat-expansion-panel-header>
                              <div class="mx-4">
                                &bull; Employer name <br>
                                &bull; EIN <br>
                                &bull; Contact name <br>
                                &bull; Telephone number <br>
                                &bull; Valid e-mail address <br>
                                &bull; Bank information: bank name, routing number, account number, type of account; checking or savings <br>
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>

                          <!------------------------------------------------------------------------------------------------>
                          <mat-accordion multi>
                            <mat-expansion-panel>
                              <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                                <div class="m-3">
                                  Can I schedule more than one payment, for example, a payment on the 15th of the month, as well as one on the 30th?
                                </div>
                              </mat-expansion-panel-header>
                              <div class="mx-4">
                                Yes, however, you will need to schedule each payment separately.
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>
                           <!------------------------------------------------------------------------------------------------>
                           <mat-accordion multi>
                            <mat-expansion-panel>
                              <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                                <div class="m-3">
                                  Can I have more than one bank account authorized for a payment?
                                </div>
                              </mat-expansion-panel-header>
                              <div class="mx-4">
                                No, you can only authorize one bank account for a payment.
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>
                          <!------------------------------------------------------------------------------------------------>
                          <mat-accordion multi>
                            <mat-expansion-panel>
                              <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                                <div class="m-3">
                                  What day will funds be withdrawn from my bank account?
                                </div>
                              </mat-expansion-panel-header>
                              <div class="mx-4">
                                Funds will be withdrawn on the scheduled payment date. If that date falls on a
                                Saturday, Sunday, or bank holiday the funds will be withdrawn the next business day.
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>
                          <!------------------------------------------------------------------------------------------------>
                          <mat-accordion multi>
                            <mat-expansion-panel>
                              <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                                <div class="m-3">
                                  How long will it take for Child Support Enforcement to receive a child support
                                  payment once it is withdrawn from my bank account?
                                </div>
                              </mat-expansion-panel-header>
                              <div class="mx-4">
                                The payment will be processed on the scheduled date unless there are technical difficulties.
                                Your employees will receive credit for the payment on the same date.
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>
                           <!------------------------------------------------------------------------------------------------>
                           <mat-accordion multi>
                            <mat-expansion-panel>
                              <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                                <div class="m-3">
                                  What happens if my payment is scheduled for a weekend or a holiday?
                                </div>
                              </mat-expansion-panel-header>
                              <div class="mx-4">
                                If a withdrawal falls on a Saturday, Sunday, or bank holiday,
                                the funds will be withdrawn the next business day. Your
                                employees will receive credit for the payment on the same date.
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>
                           <!------------------------------------------------------------------------------------------------>
                           <mat-accordion multi>
                            <mat-expansion-panel>
                              <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                                <div class="m-3">
                                  What is the earliest date that I can schedule a payment?
                                </div>
                              </mat-expansion-panel-header>
                              <div class="mx-4">
                                Your payment start date must be at least five business days from the date you register your account.
                                This will allow sufficient time for your bank account information to be verified (prenote).
                                If your account has been previously verified then the payment must be scheduled at least two business
                                days prior to its due date.
                                <br><br>
                                <span style="font-weight: 600;">Example:</span> If you register your account on Monday the 1st, you must set your payment
                                start date no earlier than Tuesday the 9th.
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>
                          <!------------------------------------------------------------------------------------------------>
                          <mat-accordion multi>
                            <mat-expansion-panel>
                              <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                                <div class="m-3">
                                  I entered a start date and the web site calculated a different date for my first payment. What am I doing wrong?
                                </div>
                              </mat-expansion-panel-header>
                              <div class="mx-4">
                                If you entered a start date that is less than five business days from today's date, your date will be
                                automatically adjusted to include the five business day verification (prenote) period.
                                <br><br>
                                <span style="font-weight: 600;">Example:</span> Today is January 26 (Monday) and you entered January 30 (Friday) as your payment start date.
                                The web site calculates the start date as February 3, taking the five business day verification period
                                into consideration; January 27 - February 2.
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------PRENOTE------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Questions about Verification (Prenote) Period
                        </mat-expansion-panel-header>
                        <mat-accordion multi>
                          <mat-expansion-panel>
                            <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                              <div class="m-3">
                                What happens after I register an account and establish a payment schedule?
                              </div>
                            </mat-expansion-panel-header>
                            <div class="mx-4">
                              If your bank account information has not been previously verified, it will be
                              submitted to your bank for verification (prenote). If the prenote is successful,
                              your payments will be withdrawn as scheduled. If the prenote is unsuccessful,
                              you will be notified by e-mail and no payment will be processed.
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                        <!------------------------------------------------------------------------------------------------>
                        <mat-accordion multi>
                          <mat-expansion-panel>
                            <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                              <div class="m-3">
                                Why would a prenote be returned as unsuccessful?
                              </div>
                            </mat-expansion-panel-header>
                            <div class="mx-4">
                              Most prenotes are returned as unsuccessful when the bank account information was entered incorrectly.
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                        <!------------------------------------------------------------------------------------------------>
                        <mat-accordion multi>
                          <mat-expansion-panel>
                            <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                              <div class="m-3">
                                I received an e-mail that the prenote was unsuccessful. What should I do now?
                              </div>
                            </mat-expansion-panel-header>
                            <div class="mx-4">
                              Edit your bank account information through this web site and reschedule your payment.
                              The prenote will be resubmitted. You may want to contact your bank if you need assistance
                              identifying the routing and account numbers.
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------EDIT OR CHANGE BANK ACCOUNTS------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Questions about Editing or Changing Bank Accounts
                        </mat-expansion-panel-header>
                        <!------------------------------------------------------------------------------------------------>
                        <mat-accordion multi>
                          <mat-expansion-panel>
                            <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                              <div class="m-3">
                                I changed my bank account, what should I do?
                              </div>
                            </mat-expansion-panel-header>
                            <div class="mx-4">
                              Submit your new bank account information when you schedule your next payment. A prenote will be sent to 
                              verify the new bank account information. If your payment is due before the end of the five business day 
                              verification (prenote) period, you will need to mail your employees’ withholdings to the Missouri Family 
                              Support Payment Center in order to avoid delinquency on their child support accounts.
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                        <!------------------------------------------------------------------------------------------------>
                         <mat-accordion multi>
                          <mat-expansion-panel>
                            <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                              <div class="m-3">
                                I authorized a bank draft and now I want to change it. What do I need to do?
                              </div>
                            </mat-expansion-panel-header>
                            <div class="mx-4">
                              Cancel your payment at this web site. You must allow two business days prior to the payment's 
                              scheduled date to cancel your payment.
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------UNAVAILABLE FUNDS------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Questions about Unavailable Funds
                        </mat-expansion-panel-header>
                        <mat-accordion multi>
                          <mat-expansion-panel>
                            <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                              <div class="m-3">
                                What if my bank account does not have sufficient funds to cover a payment?
                              </div>
                            </mat-expansion-panel-header>
                            <div class="mx-4">
                              You must cancel your payment at least two business days prior to its scheduled date.
                              You can cancel your payment at this web site.
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                        <!------------------------------------------------------------------------------------------------>
                        <mat-accordion multi>
                          <mat-expansion-panel>
                            <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                              <div class="m-3">
                                What if I fail to cancel the payment two business days prior to its
                                scheduled date and there are insufficient funds in my account?
                              </div>
                            </mat-expansion-panel-header>
                            <div class="mx-4">
                              Your account will be placed on hold and your automatic withdrawal will be cancelled. You will be 
                              required to remit all future payments with a guaranteed payment instrument such as a money order, 
                              cashier's check, or certified check. 
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                        <!------------------------------------------------------------------------------------------------>
                        <mat-accordion multi>
                          <mat-expansion-panel>
                            <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                              <div class="m-3">
                                Why is my bank account on hold?
                              </div>
                            </mat-expansion-panel-header>
                            <div class="mx-4">
                              We attempted to withdraw the funds from your bank account and they were not available. You will be 
                              required to remit all future payments by a guaranteed instrument such as a money order, cashier's check, 
                              or certified check. 
                            </div>
                          </mat-expansion-panel>
                        </mat-accordion>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                  </div>
                </div>
              </div>

              <!-----GENERAL ------------------------------------------------------------------------------------------->
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-headingFour">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour"
                    style="font-weight: bold;">
                    General FAQs
                  </button>
                </h2>
                <div id="flush-collapseFour" class="accordion-collapse collapse" aria-labelledby="flush-headingFour"
                  data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Are employers required to send child support payments electronically?
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            Employers are not required to remit payments electronically. However,
                            by submitting electronically, employers can reduce their cost for submitting child support payments.
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          I tried to register my employer on the web site, but my company name could not be located. What should I do?
                        </mat-expansion-panel-header>
                       <div class="mx-2">
                        Contact MO FSPC Customer Service at 1-888-761-3665.
                       </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Why am I unable to upload or download files with my employees’ payment information?
                        </mat-expansion-panel-header>
                       <div class="mx-2">
                        Microsoft Excel must be installed on your device to upload or download files.
                       </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                  </div>
                </div>
              </div>

              <!-----Passwords ------------------------------------------------------------------------------------------->
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-headingFour">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFour" aria-expanded="false" aria-controls="flush-collapseFour"
                    style="font-weight: bold;">
                    Passwords
                  </button>
                </h2>
                <div id="flush-collapseFour" class="accordion-collapse collapse" aria-labelledby="flush-headingFour"
                  data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          I am having trouble creating a user ID or password.
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            Your user ID and password must each consist of at least two numbers, six letters, and not exceed 12 characters 
                            in length. In addition, they cannot contain any special characters. For example, question marks, number signs, 
                            periods.
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Can my password be the same as my user ID? 
                        </mat-expansion-panel-header>
                       <div class="mx-2">
                        No, it must be different from your user ID.
                       </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Does my password ever expire?
                        </mat-expansion-panel-header>
                       <div class="mx-2">
                        No, your password does not expire.
                       </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          I forgot my password. What should I do?
                        </mat-expansion-panel-header>
                       <div class="mx-2">
                        On the login page, click "Forgot your password?", enter the required information, and create a new password.
                       </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          If I forget my password and change it but remember it later and want to change it back to the original password can I?
                        </mat-expansion-panel-header>
                       <div class="mx-2">
                        Yes, you can.
                       </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>

                  </div>
                </div>
              </div>


               <!-----TECHNICAL ISSUES---------------------------------------------------------------------------->
               <div class="accordion-item">
                <h2 class="accordion-header" id="flush-headingFive">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive"
                    style="font-weight: bold;">
                    Technical Issues
                  </button>
                </h2>
                <div id="flush-collapseFive" class="accordion-collapse collapse" aria-labelledby="flush-headingFive"
                  data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          It appears there is a problem with the web site. What should I do?
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            Contact MO FSPC Customer Service at 1-888-761-3665 to report the problem.
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                  </div>
                </div>
              </div>
              <!-----UNATHORIZED ACCESS TO ACCOUNT---------------------------------------------------------------------------->
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-headingSix">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix"
                    style="font-weight: bold;">
                    Unauthorized Access of an Account
                  </button>
                </h2>
                <div id="flush-collapseSix" class="accordion-collapse collapse" aria-labelledby="flush-headingSix"
                  data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          I believe someone has access to my web site user ID and password. What do I need to do?
                        </mat-expansion-panel-header>
                          <div class="mx-2">
                            Change your user ID and password through this web site.
                          </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                    <!------------------------------------------------------------------------------------------------>
                    <mat-accordion multi>
                      <mat-expansion-panel>
                        <mat-expansion-panel-header style="font-weight: 600; color: #174a7c">
                          Money has been withdrawn from my account without my permission. What should I do?
                        </mat-expansion-panel-header>
                       <div class="mx-2">
                        Contact MO FSPC Customer Service at 1-888-761-3665 immediately. You will be asked to submit your claim in writing.
                       </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                    <br>
                  </div>
                </div>
              </div>

              <!--------CONTACT INFORMATION------------------------------------------------------------------------------------>
              <div class="accordion-item">
                <h2 class="accordion-header" id="flush-headingSeven">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#flush-collapseSeven" aria-expanded="false" aria-controls="flush-collapseSeven"
                    style="font-weight: bold;">
                    Contact Information
                  </button>
                </h2>
                <div id="flush-collapseSeven" class="accordion-collapse collapse" aria-labelledby="flush-headingSeven"
                  data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body mx-3">
                    <h3>Address</h3>
                    MO Family Support Payment Center (MO FSPC) <br>
                    P. O. Box 109006 <br>
                    Jefferson City, MO 65110-9006 <br>
                    <br>
                    <h3>Customer Service Telephone Number</h3>
                    1-888-761-3665 <br>
                    <br>
              
                    <h3>Fax</h3>
                    1-573-761-1628 <br>
                    <br>
                    
                    <div *ngIf="this.chatLive">
                      <h3>Live Chat</h3>
                      <span>
                        <img (click)="openChat()" src="../../../../../assets/images/chaticonmid.png" alt="Customer Service Live Chat Icon" 
                        class="live-chat-btn" style="cursor: pointer">
                      </span>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
